// Presentation flags only. The API authorizes every protected request.
const keys = {
  utilizaBordo: '@utilizaBordo',
  mostraFaturamento: '@mostraFaturamento',
  mostraProducao: '@mostra_producao',
  mostraExpedicao: '@mostraExpedicao',
  mostraRecebiveis: '@mostraRecebiveis',
  mostraContaPagar: '@mostraContaPagar',
};

export function permissionEnabled(value) {
  return value === 1 || value === '1';
}

export function readSessionPermissions() {
  return Object.fromEntries(Object.entries(keys).map(([name, key]) => [name, permissionEnabled(localStorage.getItem(key)) ? 1 : 0]));
}

export function saveSessionPermissions(data) {
  Object.entries(keys).forEach(([name, key]) => localStorage.setItem(key, permissionEnabled(data[name]) ? '1' : '0'));
}

export function clearSession() {
  ['@user_token', '@NomeUsuario', ...Object.values(keys)].forEach(key => localStorage.removeItem(key));
}
